import { render, staticRenderFns } from "./SysSelecaoProdutosPorTabela.vue?vue&type=template&id=18bdbef6&scoped=true"
import script from "./SysSelecaoProdutosPorTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./SysSelecaoProdutosPorTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SysSelecaoProdutosPorTabela.vue?vue&type=style&index=0&id=18bdbef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bdbef6",
  null
  
)

export default component.exports